<template>
	<div class="main">
		<section class="panel panel-default" style="margin-bottom: 0px;">
			<header class="panel-heading" style="padding: 10px;">
				<div class="panel-actions" style="top: 7px;">
					<a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
				</div>
				<h4 class="panel-title">&emsp;</h4>
			</header>
		</section>
		<div class="tab-content">
			<div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
				<div class="row form-group">
					<div class="col-md-12">
						<table class="table table-no-more table-bordered table-striped mb-none" >
							<thead>
								<tr>
                  <th class="text-center" width="5%">學期</th>
									<th class="text-center" width="10%">學制</th>
									<th class="text-center" width="20%">系科年級</th>
									<th class="text-center" width="15%">學號</th>
									<th class="text-center" width="15%">姓名</th>
									<th class="text-center" width="15%"></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in storeData.detList" :key="index">
                  <td data-title="學期" class="text-center" >{{item.smtr}}</td>
									<td data-title="學制" class="text-center" >{{item.deptSsymStr}}</td>
									<td data-title="系科年級" class="text-center" >{{item.deptCodeStr}}{{item.drade}}年{{item.dradeClass}}班</td>
									<td data-title="學號" class="text-center" >{{item.stuAccount}}</td>
									<td data-title="姓名" class="text-center" >{{item.name}}</td>
									<td data-title="" class="text-center" >
										<a class="btn btn-link" @click="delPeople(item)">刪除</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>

				</div>
				<div class="row form-group" >
					<div class="col-md-12">
						<div class="col-md-offset-5 col-md-2">
							<a href="javascript:;" class="btn s_btn_b btn-block" @click="clickPrevious()">返回</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default{
	props:[""],
	data(){
		return{
			storeData:{},
		}
	},
	created(){
		if (this.getStore(this.$route.name) != null) {
			this.storeData = JSON.parse(this.getStore(this.$route.name));
		}
	},
	methods:{
		clickPrevious() {
			this.$router.go(-1)
		},
		delPeople(param){
			const api = `/api/RoomMage/delMagePeople/${param.smtr}/${this.storeData.mageAccount}/${param.stuAccount}`;
			let _this = this;
			bootbox.confirm("確定刪除此筆?", function(result){
				if(result){
					_this.$axios.delete(api).then(resp=>{
						let status = resp.data.status;
						bootbox.alert(resp.data.msg, function(){
							if(resp.data.status == "success"){
								_this.storeData.detList = _this.storeData.detList.filter((item, index) =>{
									return item.stuAccount != param.stuAccount;
								});
								_this.setStore(_this.$route.name, _this.storeData);
							}
						});
					});
				}
			});

		}
	},
	beforeRouteLeave(to, from, next) {
		this.removeStore(this.$route.name);
		next();
	}

}
</script>
